import Location from 'react-app-location';

export const OngoingRequestsLocation = new Location('/requests/ongoing');
